import React from 'react'
import Link from 'gatsby-link'
import { Timeline } from 'react-twitter-widgets'
import Helmet from 'react-helmet';

const IndexPage = ({data}) => (
<div className="container main-section">
  <div className="row">
    <div className="col-sm-8 level-one">
      <Helmet title="Paul Kimbrel - Web Developer and Systems Architect, Sound Engineer."/>
      <article>
        <header>
            <h2>About Me</h2>
        </header>
        <p>
          I have over 18 years of professional experience in the areas of 
          software application architecture, design and development. I also 
          have over 23 years of experience in computer science. I have been 
          a computer programmer, enthusiast, and evangelist for most of my 
          life and I continue to look for ways to expand my skills and find 
          ways of using technology to make life a little easier for everyone.
        </p>
        <p>
          I'm also very happily married and have three amazing children. 
          Fortunately, my boys have shown interest in many of the same 
          interests that I've had over the years which makes our home a 
          very interesting place. My wife and I (mostly my wife) homeschool 
          our boys and it's fun to watch them as they grow and learn.
        </p>
        <p>
          My hobbies are plentiful and it seems I'm always either planning 
          or executing some crazy project. I am doing, have done, or WILL BE doing:
        </p>
        <ul>
          <li>Music (studio engineering, guitar, vocals, sequencing)</li>
          <li>Software Development (it's not just a career)</li>
          <li>Ham Radio (<a href="http://qrz.com/db/kc9jer">KC9JER</a>)</li>
          <li>Electronic Engi*cough* Tinkering</li>
          <li>Legacy Programming (keeping history alive)</li>
          <li>Photography</li>
        </ul>
      </article>
      <article className="synopsis">
        <Link to={data.allMarkdownRemark.edges[0].node.fields.slug}>
          <header>
            <div class="latest">Latest article...</div>
            <h2 className="withDate">{data.allMarkdownRemark.edges[0].node.frontmatter.title}</h2>
            <p><time dateTime={data.allMarkdownRemark.edges[0].node.frontmatter.date}>{data.allMarkdownRemark.edges[0].node.frontmatter.date}</time></p>
          </header>
        </Link>
        <p className="excerpt">
          {data.allMarkdownRemark.edges[0].node.excerpt}
        </p>
        <Link to={data.allMarkdownRemark.edges[0].node.fields.slug}>Read more...</Link>
      </article>
    </div>
    <div className="col-sm-4 level-two">
      <Timeline dataSource={{sourceType: "profile", screenName: "pkimbrel"}}
                options={{username:"reactjs",height: "500"}} />
    </div>
  </div>
</div>
)

export const query = graphql`
query FrontPageQuery {
  allMarkdownRemark(sort: {fields: [frontmatter___date], order: DESC}) {
    edges {
      node {
        id
        frontmatter {
          title
          date(formatString: "DD MMMM, YYYY")
        }
        fields {
          slug
        }
        excerpt(pruneLength: 750)
      }
    }
  }
}
`

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js